import { render, staticRenderFns } from "./SolicitacoesConvenio.vue?vue&type=template&id=365ba6a7&"
import script from "./SolicitacoesConvenio.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports